export default __webpack_public_path__ + "fd1fe18d543939c5caae0d7bba2021e3.png";